import { render } from "./StudentCustomColumnEditHeader.vue?vue&type=template&id=f34e8574&scoped=true&ts=true"
import script from "./StudentCustomColumnEditHeader.vue?vue&type=script&lang=ts"
export * from "./StudentCustomColumnEditHeader.vue?vue&type=script&lang=ts"

import "./StudentCustomColumnEditHeader.vue?vue&type=style&index=0&id=f34e8574&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f34e8574"]])

export default __exports__